import React from 'react';
import {
  RefreshIcon,
  CalendarIcon,
  DocumentAddIcon,
} from '@heroicons/react/outline';
import { ClientSessionSource } from '../../../../../generated/graphql';
import TooltipLight from '../../../../components/TooltipLight';

const SOURCE_CONFIG: Record<
  ClientSessionSource,
  { icon: typeof CalendarIcon; label: string }
> = {
  [ClientSessionSource.CalendarAuto]: {
    icon: RefreshIcon,
    label: 'Synced automatically from Calendar',
  },
  [ClientSessionSource.CalendarManual]: {
    icon: CalendarIcon,
    label: 'Manually created from Calendar event',
  },
  [ClientSessionSource.Manual]: {
    icon: DocumentAddIcon,
    label: 'Manually created from Sessions',
  },
};

interface SessionSourceIconProps {
  source: ClientSessionSource;
  className?: string;
}

export const SessionSourceIcon: React.FC<SessionSourceIconProps> = ({
  source,
  className = '',
}) => {
  const config = SOURCE_CONFIG[source];
  if (!config)
    return <span className={['w-5', className].filter(Boolean).join(' ')} />;

  const Icon = config.icon;
  return (
    <TooltipLight content={config.label} placement="top">
      <span
        role="img"
        aria-label={config.label}
        className={['inline-flex items-center justify-center', className]
          .filter(Boolean)
          .join(' ')}
      >
        <Icon className="h-5 w-5 text-neutral-125" aria-hidden="true" />
      </span>
    </TooltipLight>
  );
};
